export const NotFound = 'NotFound';
export const Unauthorized = 'Unauthorized';
